import React, { useEffect, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';

import { CustomContainer } from '.'; // eslint-disable-line import/no-cycle
import { Gallery as ReactGallery } from '../ReactGridGallery';
import { checkImageURL, getUrls, parseImgurURL } from '../Utils';

const Gallery = props => {
  const [urls, setUrls] = useState([]);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const { data, urls } = props;

    if (Array.isArray(urls)) {
      setUrls(urls);
      setIsChecking(false);
    } else {
      const validURLS = getUrls(data)
        .map(url => parseImgurURL(url))
        .filter(url => checkImageURL(url));

      setUrls(validURLS);
      setIsChecking(false);
    }
  }, [props.data, props.urls]);

  if (!urls.length) {
    return null;
  }

  return (
    <CustomContainer>
      <Header as="h2" attached="top">
        多媒體
      </Header>
      <Segment attached loading={isChecking}>
        <picture>
          <ReactGallery
            enableImageSelection={false}
            images={urls.map(url => ({
              src: url,
            }))}
          />
        </picture>
      </Segment>
    </CustomContainer>
  );
};

export default Gallery;
